import posthog from 'posthog-js'
import { StrictMode, startTransition, useEffect } from 'react'
import { hydrate } from 'react-dom'
import { v4 as uuidv4 } from 'uuid'

import { RemixBrowser, useLocation, useMatches } from '@remix-run/react'

import { SetClientDeviceCookies } from './components/SetClientDeviceCookies'
import { REACT_APP_PUBLIC_POSTHOG_HOST, REACT_APP_PUBLIC_POSTHOG_KEY } from './utils/constant'

function PosthogInit() {
  useEffect(() => {
    const SESSION_KEY = 'ph_custom_session_id'
    const customSessionId = localStorage?.getItem(SESSION_KEY) ?? uuidv4()
    localStorage?.setItem(SESSION_KEY, customSessionId)
    posthog?.init(REACT_APP_PUBLIC_POSTHOG_KEY, {
      api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
      person_profiles: 'identified_only',
      loaded: (phog) => {
        phog?.register_for_session({ custom_session_id: customSessionId })
        phog?.capture('$session_started')
      },
    })
  }, [])

  return null
}

startTransition(() => {
  hydrate(
    <StrictMode>
      <RemixBrowser />
      <PosthogInit />
      <SetClientDeviceCookies />
    </StrictMode>,
    document,
  )
})
